export interface PlaybackParams {
  startTime?: number
  endTime?: number
  forceAutoplay: boolean
}

function parseNumber(value: string | number | null | undefined): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined
  }
  const parsed = Number(value)
  return Number.isNaN(parsed) ? undefined : parsed
}

export function playbackParams(url: string, timestamp?: number | null): PlaybackParams {
  const params = new URL(url, document.baseURI).searchParams

  let t = params.get('t')

  // The native app appends a "t"-param with a unix timestamp, when a video is opened in the app via a
  // link (e.g. from google). This causes the video to jump to the end. We try to guess whether a t
  // param is a unix-timestamp and reset it in order to prevent this buggy behavior.
  if (t && Number(t) > 10000) {
    t = null
  }

  return {
    startTime: parseNumber(t) ?? parseNumber(params.get('start_time')) ?? parseNumber(timestamp),
    endTime: parseNumber(params.get('end_time')),
    // An explicit position — from the URL or from the page — means the user asked for this spot, so
    // play even where autoplay is otherwise off. `timestamp === 0` counts as explicit.
    forceAutoplay: Boolean(t) || timestamp === 0 || parseNumber(timestamp) !== undefined,
  }
}
